import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';
import { CTA } from '../components/Layout/CTA';

import '../components/GlobalStyle.css';

import Convenient from '../assets/images/Payments - Convenient Payment Initiation.png';
import RoleBased from '../assets/images/Payments - Role Based.png';
import Security from '../assets/images/Payments - Robust Security.png';
import CircleIcon7 from '../assets/icons/BPS Icon - Circle 7.png';
import CircleIcon5 from '../assets/icons/BPS Icon - Circle 5.png';
import CircleIcon6 from '../assets/icons/BPS Icon - Circle 6.png';


import { FadeLoad, FadeLoadDelay, FadeScroll } from '../components/styled/Motion.styled';
import { BPSCheckmarkList, Checkmark } from '../components/styled/Lists';

const CheckCardHover = styled.span`
    box-shadow: 0px 0px 4px #cccccc;
    padding: 1rem;
    border: 1px solid transparent;
    background-color: #ffffff;
    border-radius: .5rem;
    margin: .5rem auto;
    display: inline-block;
    transition: .5s ease;
    font-weight: bold;
    color: #4d4d4d;

    &:hover {
        border: 1px solid #D4DEEF;
        box-shadow: 10px 10px 0px #D4DEEF;
    }

`



const Payments = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Programs | Payments</title>
                <link rel="canonical" href="https://bestpayment.solutions/payments" />
            </Helmet>

            <Navigation />
            <Container fluid className='vh-75 circle-bg-5-scroll'>
                <FadeLoad>
                    <Row className='align-items-center justify-content-evenly py-5 text-center text-lg-start'>
                        <Col lg={5}>
                            <h2 className='fw-bold fs-24 color-sky-tint-1'>Payments</h2>
                            <h1 className='fs-48'>
                                Enjoy efficient, secure, and reliable payment services
                            </h1>
                            <p>
                                When your money is on the line, you need to know your payments are handled properly. At Best Payment Solutions, we offer seamless integration, robust security, and unparalleled ease in handling payments of all types and sizes. We provide options for both stand-alone services and add-ons to rebate or incentive programs. Our platform is designed to save time, reduce errors, and enhance financial oversight. With our platform, we can:
                            </p>
                        </Col>
                        <Col lg={4}>
                            <FadeLoadDelay>
                                <CheckCardHover><Checkmark /> Automate regular payments</CheckCardHover>
                                <br />
                                <CheckCardHover className='ms-lg-3'><Checkmark /> Manage complex reimbursement processes</CheckCardHover>
                                <br />
                                <CheckCardHover className='ms-lg-5'><Checkmark /> Provide flexible payment options to recipients</CheckCardHover>
                            </FadeLoadDelay>
                        </Col>
                    </Row>
                </FadeLoad>
            </Container>
            <Container fluid className='py-5 bg-cream'>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col xs={12}>
                        <h3 className='fs-48 text-center'>What to expect from our payment services</h3>
                    </Col>
                </Row>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={5} sm={10}>
                        <FadeScroll>
                            <img src={Convenient} width='100%' />
                        </FadeScroll>
                    </Col>
                    <Col lg={5}>
                        <h5 className='fw-bold pt-4 fs-24'>Convenient payment initiation</h5>
                        <p>
                            Whether it’s management or customer service, we offer simple solutions for initiating the payment process. We have options available for single-form submissions or batch file uploads. Payments can be designated for a variety of client-selected reasons, including legal actions, customer reimbursements, covering damages, and more.
                        </p>

                        <h5 className='fw-bold pt-4 fs-24'>Diverse payment options</h5>
                        <p>
                            Choose from checks, ACH payments, or prepaid Visa cards, either virtual or physical. Payment methods can be selected by our clients, or payees can select how they’d like to receive their payments. We process payments daily to ensure timely distribution. Payments can be one-time or scheduled to go out over periods of months or even years, with meticulous record-keeping for effortless tracking.
                        </p>
                    </Col>
                </Row>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={5} className='order-2 order-lg-1'>
                        <h5 className='fw-bold pt-4 fs-24'>Strict approval process</h5>
                        <p>
                            Every payment request undergoes a rigorous review, utilizing our AI technology integrated with your program rules. This ensures compliance and accuracy for all payments.
                        </p>

                        <h5 className='fw-bold pt-4 fs-24'>Role-based access control</h5>
                        <p>
                            Assign specific roles like approvers, data entry personnel, and support staff to ensure all payments are handled by the right person at every step of the process.
                        </p>

                        <h5 className='fw-bold pt-4 fs-24'>Real-time approval dashboard</h5>
                        <p>
                            Review payment activity data at a moment’s notice. We value transparency, so we ensure you have access to detailed reporting on every aspect of the payment process. If it’s information we collect, it’s information you can access.
                        </p>
                    </Col>
                    <Col lg={5} sm={10} className='order-1 order-lg-2'>
                        <FadeScroll>
                            <img src={RoleBased} width='100%' />
                        </FadeScroll>
                    </Col>
                </Row>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={5} sm={10}>
                        <FadeScroll>
                            <img src={Security} width='100%' />
                        </FadeScroll>
                    </Col>
                    <Col lg={5}>
                        <h5 className='fw-bold pt-4 fs-24'>Robust security</h5>
                        <p>
                            We maintain the highest standards of security, staying ahead of any potential security breaches. Some of our security measures include:
                        </p>
                        <BPSCheckmarkList>
                            <ul>
                                <li>
                                    <Checkmark />Regular data backups.
                                </li>
                                <li>
                                    <Checkmark />Security audits.
                                </li>
                                <li>
                                    <Checkmark />Constant innovation.
                                </li>
                            </ul>
                        </BPSCheckmarkList>

                        <h5 className='fw-bold pt-4 fs-24'>Account management & customer service</h5>
                        <p>
                            We assign each of our clients a dedicated account manager who will be there with you, ensuring your payment program runs smoothly every step of the way. Additionally, our amazing customer service team is here to provide comprehensive support on all aspects of our payment services.
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='vh-75 text-center py-5'>
                <FadeScroll>
                    <Row className="justify-content-evenly pt-4">
                        <Col xs={12}>
                            <h3 className='fs-48'>Why choose us?</h3>
                        </Col>
                        <Col lg={3} md className='pt-4'>
                            <img src={CircleIcon6} width={60} />
                            <h5 className='fw-bold pt-4'>Efficient & scalable</h5>
                            <p>
                                Our payment services are fast, convenient and designed to handle large volumes of payments. This significantly reduces your in-house processing workload.
                            </p>
                        </Col>
                        <Col lg={3} md className='pt-4'>
                            <img src={CircleIcon7} width={60} />
                            <h5 className='fw-bold pt-4'>Time-saving & economical</h5>
                            <p>
                                We automate the payment process to reduce your costs and keep your team focused on their most important tasks.
                            </p>
                        </Col>
                        <Col lg={3} md className='pt-4'>
                            <img src={CircleIcon5} width={60} />
                            <h5 className='fw-bold pt-4'>Dedicated support</h5>
                            <p>
                                We provide specialized teams for implementation, account management, and technical assistance. You can be confident that your payment program is in good hands.
                            </p>
                        </Col>
                    </Row>
                </FadeScroll>
            </Container>
            <Container fluid className='bg-sky-tint-3 py-5'>
                <CTA />
            </Container>
            <Footer />
        </>
    );
}

export default Payments;